import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "d-flex align-center justify-start" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "d-flex justify-start align-center" }
const _hoisted_5 = {
  key: 0,
  class: "text-left"
}
const _hoisted_6 = ["data-cy"]
const _hoisted_7 = ["data-cy"]
const _hoisted_8 = { class: "text-center wrapper" }
const _hoisted_9 = ["data-cy"]
const _hoisted_10 = ["data-cy"]
const _hoisted_11 = ["data-cy"]
const _hoisted_12 = ["data-cy"]
const _hoisted_13 = ["data-cy"]
const _hoisted_14 = { class: "text-center wrapper" }
const _hoisted_15 = ["data-cy"]
const _hoisted_16 = ["data-cy"]
const _hoisted_17 = ["data-cy"]
const _hoisted_18 = ["data-cy"]
const _hoisted_19 = {
  class: "text-center",
  style: {"width":"750px"}
}
const _hoisted_20 = { style: {"width":"750px"} }
const _hoisted_21 = { style: {"margin-bottom":"0px","margin-left":"5px"} }
const _hoisted_22 = { class: "d-flex align-center justify-start" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "d-flex justify-start align-center" }
const _hoisted_25 = {
  key: 0,
  class: "text-left"
}
const _hoisted_26 = ["data-cy"]
const _hoisted_27 = ["data-cy"]
const _hoisted_28 = ["data-cy"]
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = ["data-cy"]
const _hoisted_31 = { class: "text-center wrapper" }
const _hoisted_32 = ["data-cy"]
const _hoisted_33 = ["data-cy"]
const _hoisted_34 = ["data-cy"]
const _hoisted_35 = ["data-cy"]
const _hoisted_36 = {
  class: "text-center",
  style: {"width":"750px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_ossCompanySelector = _resolveComponent("ossCompanySelector")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_ControlTVA = _resolveComponent("ControlTVA")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_TaxFormEDIReport = _resolveComponent("TaxFormEDIReport")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "6",
          class: "pt-3 pl-3 pr-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.localSelectedWindow,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localSelectedWindow) = $event)),
              "fixed-tabs": "",
              class: "rounded-xl",
              color: "primary"
            }, {
              default: _withCtx(() => [
                (_ctx.isAllowedToDeclaration)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 0,
                      value: "commonStatements",
                      href: "#commonStatements",
                      class: "v-tab-rounded-0"
                    }, {
                      default: _withCtx(() => _cache[53] || (_cache[53] = [
                        _createTextVNode("Déclarations courantes")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isAllowedToBundles)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 1,
                      value: "taxDeclarations",
                      href: "#taxDeclarations",
                      class: "v-tab-rounded-0",
                      "data-cy": "TaxFormList-bundleTab"
                    }, {
                      default: _withCtx(() => _cache[54] || (_cache[54] = [
                        _createTextVNode(" Liasses fiscales ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            (_ctx.localSelectedWindow === 'commonStatements')
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: _ctx.isInAdmin ? 3 : 4,
                      class: "pt-3 pr-2 d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.sortBy,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sortBy) = $event)),
                          items: _ctx.sortByItems,
                          label: "Tri par date de déclaration",
                          outlined: "",
                          "hide-details": "auto",
                          density: "compact"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.isInAdmin ? 3 : 4,
                      class: "pt-3 pr-2 d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.declarationType,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.declarationType) = $event)),
                          items: _ctx.declarationTypeInformationTable,
                          "item-title": "text",
                          "item-value": "value",
                          label: "Filtrer par type",
                          outlined: "",
                          "hide-details": "auto",
                          density: "compact",
                          "data-cy": "TaxFormList-declarationTypeSelector"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.isInAdmin ? 3 : 4,
                      class: "pt-3 pr-2 d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.declarationStatus,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.declarationStatus) = $event)),
                          items: _ctx.translateDeclarationStatusTable,
                          "item-title": "text",
                          "item-value": "value",
                          label: "Filtrer par statut",
                          outlined: "",
                          "hide-details": "auto",
                          density: "compact",
                          "data-cy": "TaxFormList-declarationStatusSelector"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    (_ctx.isInAdmin)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "4",
                          class: "pt-3 pr-2 d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ossCompanySelector, {
                              modelValue: _ctx.companiesSelected,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companiesSelected) = $event)),
                              multiple: true,
                              items: _ctx.allAvailableCompanies,
                              label: 'Société',
                              "hide-details": "auto",
                              "data-cy": "TaxFormList-companySelector"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: _ctx.isInAdmin ? 4 : 6,
                      class: "pt-3 pr-2 d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.bundleType,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bundleType) = $event)),
                          items: _ctx.bundleTypeInformationTable,
                          "item-title": "text",
                          "item-value": "value",
                          label: "Filtrer par type",
                          outlined: "",
                          "hide-details": "auto",
                          density: "compact",
                          "data-cy": "TaxFormList-bundleTypeSelector"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.isInAdmin ? 4 : 6,
                      class: "pt-3 pr-2 d-flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.bundleStatus,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bundleStatus) = $event)),
                          items: _ctx.translateBundleStatusTable,
                          "item-title": "text",
                          "item-value": "value",
                          label: "Filtre par statut",
                          outlined: "",
                          "hide-details": "auto",
                          density: "compact",
                          "data-cy": "TaxFormList-bundleStatusSelector"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    (_ctx.isInAdmin)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "4",
                          class: "pt-3 pr-2 d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ossCompanySelector, {
                              modelValue: _ctx.companiesSelected,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.companiesSelected) = $event)),
                              multiple: true,
                              items: _ctx.allAvailableCompanies,
                              label: 'Société',
                              "hide-details": "auto",
                              "data-cy": "TaxFormList-bundleCompanySelector"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_tabs_window, {
      modelValue: _ctx.localSelectedWindow,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.localSelectedWindow) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tabs_window_item, { value: "commonStatements" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "px-4 d-flex align-center"
            }, {
              default: _withCtx(() => [
                (!_ctx.isInAdmin)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "2",
                      class: "d-flex justify-space-around align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tooltip, {
                          disabled: !_ctx.isNewDeclarationDisabled,
                          location: "end"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_primary, _mergeProps(props, {
                              block: "",
                              elevation: "0",
                              class: "rounded-lg gradient mt-2",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openTaxFormCreateDialog2())),
                              disabled: _ctx.isNewDeclarationDisabled,
                              size: "large"
                            }), {
                              default: _withCtx(() => _cache[55] || (_cache[55] = [
                                _createTextVNode(" Nouvelle déclaration ")
                              ])),
                              _: 2
                            }, 1040, ["disabled"])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", { innerHTML: _ctx.tooltipMessage }, null, 8, _hoisted_1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_ControlTVA, { class: "ml-2" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "mt-2",
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table_server, {
                      "items-per-page": _ctx.declarationsPerPage,
                      "onUpdate:itemsPerPage": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.declarationsPerPage) = $event)),
                      page: _ctx.declarationsPage,
                      "onUpdate:page": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.declarationsPage) = $event)),
                      headers: _ctx.declarationsTableHeaders,
                      items: _ctx.sortedDeclarations,
                      "items-length": _ctx.totalDeclarations,
                      "items-per-page-options": [10, 20, 50, 100],
                      "item-key": "id",
                      class: "table",
                      "fixed-header": "",
                      height: "65vh",
                      hover: true,
                      "prev-icon": "$chevron-left",
                      "next-icon": "$chevron_right",
                      "data-cy": "TaxFormList-table"
                    }, {
                      [`header.declarationDate`]: _withCtx(() => _cache[56] || (_cache[56] = [
                        _createElementVNode("div", null, [
                          _createTextVNode("Date de"),
                          _createElementVNode("br"),
                          _createTextVNode("déclaration")
                        ], -1)
                      ])),
                      [`header.createdAt`]: _withCtx(() => _cache[57] || (_cache[57] = [
                        _createElementVNode("div", null, [
                          _createTextVNode("Date de"),
                          _createElementVNode("br"),
                          _createTextVNode("création")
                        ], -1)
                      ])),
                      [`header.updatedAt`]: _withCtx(() => _cache[58] || (_cache[58] = [
                        _createElementVNode("div", null, [
                          _createTextVNode("Date de dernière"),
                          _createElementVNode("br"),
                          _createTextVNode("modification")
                        ], -1)
                      ])),
                      [`header.mtaeProof`]: _withCtx(() => _cache[59] || (_cache[59] = [
                        _createElementVNode("div", null, [
                          _createTextVNode("Justificatif"),
                          _createElementVNode("br"),
                          _createTextVNode("EDI")
                        ], -1)
                      ])),
                      [`header.checkbox`]: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_v_checkbox, {
                            color: "primary",
                            indeterminate: 
                                            !!_ctx.declarationsSelected.length &&
                                            _ctx.declarationsSelected.length !==
                                                _ctx.filteredDeclarations.length
                                        ,
                            class: "pa-0 ma-0 mr-1 pl-1",
                            ripple: false,
                            "hide-details": "",
                            disabled: !_ctx.filteredDeclarations.length,
                            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.selectAllDeclarations()), ["stop"])),
                            "model-value": 
                                            _ctx.filteredDeclarations.length !== 0 &&
                                            _ctx.declarationsSelected.length ===
                                                _ctx.filteredDeclarations.length
                                        
                          }, null, 8, ["indeterminate", "disabled", "model-value"]),
                          (_ctx.isAccountingUser)
                            ? (_openBlock(), _createBlock(_component_v_menu, {
                                key: 0,
                                "offset-y": ""
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_icon, _mergeProps(props, {
                                    class: "ml-9",
                                    icon: "$dots_vertical"
                                  }), null, 16)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item, {
                                        disabled: _ctx.isDeleteDeclarationDisable,
                                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogDeleteSelectedDeclaration = true))
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            disabled: _ctx.isDeleteDeclarationDisable,
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => _cache[61] || (_cache[61] = [
                                              _createTextVNode("$delete")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => _cache[60] || (_cache[60] = [
                                              _createTextVNode("Supprimer")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      "no-data": _withCtx(() => _cache[62] || (_cache[62] = [
                        _createTextVNode("Aucune déclaration")
                      ])),
                      item: _withCtx(({ item }) => [
                        _createElementVNode("tr", {
                          onClick: ($event: any) => (_ctx.openDeclaration(item))
                        }, [
                          _createElementVNode("td", _hoisted_4, [
                            _createVNode(_component_v_checkbox, {
                              color: "primary",
                              "hide-details": "",
                              class: "mt-0 pt-0 ml-1",
                              onClick: _withModifiers(($event: any) => (_ctx.selectDeclaration(item.id)), ["stop"]),
                              "model-value": _ctx.declarationsSelected.includes(item.id)
                            }, null, 8, ["onClick", "model-value"])
                          ]),
                          (_ctx.isInAdmin)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
                                _createElementVNode("b", {
                                  "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-company`
                                }, _toDisplayString(item.company.name), 9, _hoisted_6)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", {
                            class: _normalizeClass(_ctx.isInAdmin ? 'text-center' : 'text-left')
                          }, [
                            _createElementVNode("b", {
                              id: "cerfaNumber",
                              "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-cerfaNumber`
                            }, _toDisplayString(item.cerfaNumber), 9, _hoisted_7)
                          ], 2),
                          _createElementVNode("td", _hoisted_8, [
                            _createElementVNode("p", {
                              class: "line-clamp-2",
                              "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-name`
                            }, _toDisplayString(item.name), 9, _hoisted_9)
                          ]),
                          _createElementVNode("td", {
                            class: "text-center",
                            "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-period`
                          }, _toDisplayString(item.period), 9, _hoisted_10),
                          _createElementVNode("td", {
                            class: "text-center",
                            "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-year`
                          }, _toDisplayString(item.year), 9, _hoisted_11),
                          _createElementVNode("td", {
                            class: "text-right",
                            "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-amountDeclared`
                          }, [
                            (item.amountDeclaredToDisplay)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(item.amountDeclaredToDisplay), 1)
                                ], 64))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  color: "primary",
                                  size: "x-large"
                                }, {
                                  default: _withCtx(() => _cache[63] || (_cache[63] = [
                                    _createTextVNode("$dot")
                                  ])),
                                  _: 1
                                }))
                          ], 8, _hoisted_12),
                          _createElementVNode("td", {
                            class: "text-right",
                            "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-amountPaid`
                          }, [
                            (item.amountPaid)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(item.amountPaid), 1)
                                ], 64))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  color: "primary",
                                  size: "x-large"
                                }, {
                                  default: _withCtx(() => _cache[64] || (_cache[64] = [
                                    _createTextVNode("$dot")
                                  ])),
                                  _: 1
                                }))
                          ], 8, _hoisted_13),
                          _createElementVNode("td", _hoisted_14, [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                                                item.status === 'ERROR'
                                                    ? 'text-red line-clamp-2'
                                                    : 'line-clamp-2'
                                            ),
                              "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-status`
                            }, _toDisplayString(item.translateStatus), 11, _hoisted_15)
                          ]),
                          _createElementVNode("td", {
                            class: "text-center",
                            "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-declarationDate`
                          }, [
                            (item.date)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.formatDateWithSlash(item.date)), 1)
                                ], 64))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  color: "primary",
                                  size: "x-large"
                                }, {
                                  default: _withCtx(() => _cache[65] || (_cache[65] = [
                                    _createTextVNode("$dot")
                                  ])),
                                  _: 1
                                }))
                          ], 8, _hoisted_16),
                          _createElementVNode("td", {
                            class: "text-center",
                            "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-creationDate`
                          }, _toDisplayString(item.createdAt
                                                ? _ctx.formatDateWithSlash(item.createdAt)
                                                : ""), 9, _hoisted_17),
                          _createElementVNode("td", {
                            class: "text-center",
                            "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-LastUpdateDate`
                          }, _toDisplayString(item.updatedAt
                                                ? _ctx.formatDateWithSlash(item.updatedAt)
                                                : ""), 9, _hoisted_18),
                          _createElementVNode("td", null, [
                            _createVNode(_component_TaxFormEDIReport, {
                              taxFormId: item.id,
                              onMtaeProofEvent: _ctx.mtaeProof,
                              isDeclaration: true,
                              "data-cy": `declaration-${item.company.name.split(' ')[0]}-${item.cerfaNumber}-ediProof`,
                              companyFromTaxFormListForAdminMode: item.company,
                              accountingPeriodFromTaxFormListForAdminMode: 
                                                _ctx.isInAdmin && item.accountingPeriod
                                            
                            }, null, 8, ["taxFormId", "onMtaeProofEvent", "data-cy", "companyFromTaxFormListForAdminMode", "accountingPeriodFromTaxFormListForAdminMode"])
                          ])
                        ], 8, _hoisted_3)
                      ]),
                      _: 2
                    }, 1032, ["items-per-page", "page", "headers", "items", "items-length"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.dialogDeleteSelectedDeclaration)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 0,
                  modelValue: _ctx.dialogDeleteSelectedDeclaration,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.dialogDeleteSelectedDeclaration) = $event)),
                  title: "Suppression",
                  onValid: _cache[14] || (_cache[14] = ($event: any) => (_ctx.deleteDeclarations()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("b", null, " Voulez-vous supprimer " + _toDisplayString(_ctx.declarationsSelected.length === 1
                                    ? "la"
                                    : _ctx.declarationsSelected.length) + " déclaration" + _toDisplayString(_ctx.declarationsSelected.length === 1 ? "" : "s") + " ? ", 1),
                      _cache[66] || (_cache[66] = _createElementVNode("br", null, null, -1)),
                      _cache[67] || (_cache[67] = _createElementVNode("br", null, null, -1)),
                      _cache[68] || (_cache[68] = _createElementVNode("b", null, "Attention, la suppression d'une déclaration entraîne la suppression de l'écriture d'OD et les lettrages afférents le cas échéant.", -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.dialogCreateTaxForm2,
              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.dialogCreateTaxForm2) = $event)),
              title: 
                        _ctx.newDeclarationStep2 === 'prefilterSelection'
                            ? 'Sélectionnez le type de formulaire'
                            : _ctx.newDeclarationStep2 === 'declarationSelection'
                              ? 'Sélectionnez le formulaire à remplir'
                              : 'Période de déclaration'
                    ,
              onPrevious: _cache[36] || (_cache[36] = ($event: any) => (_ctx.goToPreviousTab())),
              "previous-display": _ctx.newDeclarationStep2 !== 'prefilterSelection',
              onValid: _cache[37] || (_cache[37] = ($event: any) => (_ctx.validNewDeclarationDialog2())),
              "valid-disabled": _ctx.isNewDeclarationDialogValidDisabled,
              hideValid: 
                        ['prefilterSelection', 'declarationSelection'].includes(_ctx.newDeclarationStep2)
                    ,
              onClose: _cache[38] || (_cache[38] = ($event: any) => (_ctx.resetNewDeclarationDialog2()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_v_window, {
                    modelValue: _ctx.newDeclarationStep2,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.newDeclarationStep2) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window_item, { value: "prefilterSelection" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              (
                                            _ctx.companyDeclarationConditions.find((condition) =>
                                                condition.includes('Tva'),
                                            )
                                        )
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 0,
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.prefilterForms('Tva'))),
                                    title: "TVA",
                                    class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        )
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => _cache[69] || (_cache[69] = [
                                          _createTextVNode("$fa-chevron-right")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"]))
                                : _createCommentVNode("", true),
                              (
                                            _ctx.companyDeclarationConditions.includes(
                                                'isRegimeFiscalIS',
                                            )
                                        )
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 1,
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.prefilterForms('isRegimeFiscalIS'))),
                                    title: "IS",
                                    class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        )
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => _cache[70] || (_cache[70] = [
                                          _createTextVNode("$fa-chevron-right")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"]))
                                : _createCommentVNode("", true),
                              (
                                            _ctx.companyDeclarationConditions.includes('isCVAESubject')
                                        )
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 2,
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.prefilterForms('isCVAESubject'))),
                                    title: "CVAE",
                                    class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        )
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => _cache[71] || (_cache[71] = [
                                          _createTextVNode("$fa-chevron-right")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"]))
                                : _createCommentVNode("", true),
                              (
                                            _ctx.companyDeclarationConditions.includes('isDAS2Subject')
                                        )
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 3,
                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.prefilterForms('isDAS2Subject'))),
                                    title: "DAS2",
                                    class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        )
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => _cache[72] || (_cache[72] = [
                                          _createTextVNode("$fa-chevron-right")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"]))
                                : _createCommentVNode("", true),
                              (_ctx.companyDeclarationConditions.includes('isRCMSubject'))
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 4,
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.prefilterForms('isRCMSubject'))),
                                    title: "RCM",
                                    class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        )
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => _cache[73] || (_cache[73] = [
                                          _createTextVNode("$fa-chevron-right")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"]))
                                : _createCommentVNode("", true),
                              (_ctx.companyDeclarationConditions.includes('isIFUSubject'))
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 5,
                                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.prefilterForms('isIFUSubject'))),
                                    title: "IFU",
                                    class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                : 'my-2 px-2 oss-list-item rounded-xl border'
                                        )
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "small" }, {
                                        default: _withCtx(() => _cache[74] || (_cache[74] = [
                                          _createTextVNode("$fa-chevron-right")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: "declarationSelection" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              (
                                            _ctx.selectedCompany &&
                                            _ctx.selectedCompany.vatSystem &&
                                            !_ctx.isNotSubjectToVAT(_ctx.selectedCompany.vatSystem) &&
                                            _ctx.prefilter === 'Tva'
                                        )
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "12",
                                    class: "mr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item, {
                                        ripple: "",
                                        onClick: _cache[21] || (_cache[21] = ($event: any) => {
                                                _ctx.newDeclarationStep2 = 'vatAutoDatesSelection';
                                                _ctx.selectedDeclarationForm.cerfaNumber =
                                                    _ctx.companyDeclarationConditions.includes(
                                                        'isTvaRegimeReel',
                                                    )
                                                        ? '3310CA3'
                                                        : _ctx.companyDeclarationConditions.includes(
                                                                'isTvaRegimeAgricole',
                                                            )
                                                          ? '3517BCA12'
                                                          : '3517SCA12';
                                            }),
                                        class: _normalizeClass(
                                                !_ctx.$vuetify.display.mobile
                                                    ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                    : 'my-2 px-2 oss-list-item rounded-xl border'
                                            )
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            disabled: _ctx.isDeleteBundleDisable,
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => _cache[76] || (_cache[76] = [
                                              _createTextVNode("$fa-chevron-right")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => _cache[75] || (_cache[75] = [
                                              _createTextVNode("Déclaration de TVA automatique")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item_subtitle, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.companyDeclarationConditions.includes(
                                                    "isTvaRegimeReel",
                                                )
                                                    ? "3310CA3"
                                                    : _ctx.companyDeclarationConditions.includes(
                                                            "isTvaRegimeAgricole",
                                                        )
                                                      ? "3517BCA12"
                                                      : "3517SCA12"), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["class"]),
                                      _createVNode(_component_v_list_item, {
                                        ripple: "",
                                        onClick: _cache[22] || (_cache[22] = ($event: any) => {
                                                _ctx.newDeclarationStep2 = 'vatAssistDatesSelection';
                                                _ctx.selectedDeclarationForm.cerfaNumber =
                                                    _ctx.companyDeclarationConditions.includes(
                                                        'isTvaRegimeReel',
                                                    )
                                                        ? '3310CA3'
                                                        : _ctx.companyDeclarationConditions.includes(
                                                                'isTvaRegimeAgricole',
                                                            )
                                                          ? '3517BCA12'
                                                          : '3517SCA12';
                                            }),
                                        class: _normalizeClass(
                                                !_ctx.$vuetify.display.mobile
                                                    ? 'my-2 py-3 mb-5 oss-list-item rounded-xl border'
                                                    : 'my-2 mb-5 px-2 oss-list-item rounded-xl border'
                                            )
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            disabled: _ctx.isDeleteBundleDisable,
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => _cache[78] || (_cache[78] = [
                                              _createTextVNode("$fa-chevron-right")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => _cache[77] || (_cache[77] = [
                                                _createTextVNode("Assistant à la déclaration de TVA")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_list_item_subtitle, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.companyDeclarationConditions.includes(
                                                        "isTvaRegimeReel",
                                                    )
                                                        ? "3310CA3"
                                                        : _ctx.companyDeclarationConditions.includes(
                                                                "isTvaRegimeAgricole",
                                                            )
                                                          ? "3517BCA12"
                                                          : "3517SCA12"), 1)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["class"]),
                                      _createVNode(_component_v_divider, { class: "mb-4" })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.prefilter === 'isDAS2Subject')
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 1,
                                    cols: "12",
                                    class: "mr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item, {
                                        ripple: "",
                                        onClick: _cache[23] || (_cache[23] = ($event: any) => {
                                                _ctx.newDeclarationStep2 = 'declarationDatesSelection';
                                                _ctx.selectedDeclarationForm.cerfaNumber = 'DAS2';
                                            }),
                                        class: _normalizeClass(
                                                !_ctx.$vuetify.display.mobile
                                                    ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                    : 'my-2 px-2 oss-list-item rounded-xl border'
                                            )
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_icon, { size: "small" }, {
                                            default: _withCtx(() => _cache[81] || (_cache[81] = [
                                              _createTextVNode("$fa-chevron-right")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => _cache[79] || (_cache[79] = [
                                              _createTextVNode("Assistant DAS2")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item_subtitle, null, {
                                            default: _withCtx(() => _cache[80] || (_cache[80] = [
                                              _createTextVNode("DAS2")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["class"])
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_col, {
                                    key: 2,
                                    cols: "12",
                                    class: "mr-2"
                                  }, {
                                    default: _withCtx(() => [
                                      (!_ctx.sortedDeclarationTypes2.length)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            cols: "12",
                                            class: "d-flex",
                                            style: {"height":"432px"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_progress_circular, {
                                                indeterminate: "",
                                                size: "28",
                                                class: "mx-auto",
                                                color: "primary"
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_virtual_scroll, {
                                            key: 1,
                                            items: _ctx.sortedDeclarationTypes2,
                                            "item-height": "66",
                                            height: "432"
                                          }, {
                                            default: _withCtx(({ item }) => [
                                              (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: item.name,
                                                ripple: "",
                                                onClick: ($event: any) => {
                                                        _ctx.selectedDeclarationForm = item;
                                                        _ctx.newDeclarationStep2 =
                                                            'declarationDatesSelection';
                                                    },
                                                class: _normalizeClass(
                                                        !_ctx.$vuetify.display.mobile
                                                            ? 'my-2 py-3 oss-list-item rounded-xl border'
                                                            : 'my-2 px-2 oss-list-item rounded-xl border'
                                                    )
                                              }, {
                                                append: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    disabled: _ctx.isDeleteBundleDisable,
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[82] || (_cache[82] = [
                                                      _createTextVNode("$fa-chevron-right")
                                                    ])),
                                                    _: 1
                                                  }, 8, ["disabled"])
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(item.name), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_list_item_subtitle, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(item.cerfaNumber), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick", "class"]))
                                            ]),
                                            _: 1
                                          }, 8, ["items"]))
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: "declarationDatesSelection" }, {
                        default: _withCtx(() => [
                          (
                                        ['1329AC', '2571', '3514', '3525BIS'].includes(
                                            _ctx.selectedDeclarationForm.cerfaNumber,
                                        )
                                    )
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                "no-gutters": "",
                                class: "my-5 d-flex justify-center align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "5",
                                    class: "d-flex justify-end align-center"
                                  }, {
                                    default: _withCtx(() => _cache[83] || (_cache[83] = [
                                      _createElementVNode("h3", null, "Sélectionnez la période de l'acompte :", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "3",
                                    class: "ml-2 d-flex justify-start align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        items: _ctx.periodSelectorItems,
                                        "item-title": "text",
                                        "item-value": "value",
                                        modelValue: _ctx.depositPeriod,
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.depositPeriod) = $event)),
                                        dense: "",
                                        label: "Sélectionner",
                                        outlined: "",
                                        "hide-details": "auto"
                                      }, null, 8, ["items", "modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "4" })
                                ]),
                                _: 1
                              }))
                            : (
                                        ['3310CA3'].includes(_ctx.selectedDeclarationForm.cerfaNumber)
                                    )
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 1,
                                  "no-gutters": "",
                                  class: "my-5 d-flex justify-center align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "d-flex justify-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          items: _ctx.CA3Periods,
                                          "item-title": "text",
                                          "item-value": "value",
                                          modelValue: _ctx.selectedCA3Period,
                                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.selectedCA3Period) = $event)),
                                          dense: "",
                                          label: "Période",
                                          outlined: "",
                                          "hide-details": "auto"
                                        }, null, 8, ["items", "modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (
                                        ['3519', '2561', '2777', '3517DDR'].includes(
                                            _ctx.selectedDeclarationForm.cerfaNumber,
                                        )
                                    )
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 2,
                                    "no-gutters": "",
                                    class: "my-5 d-flex justify-center align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            class: "mt-5 d-flex justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "6",
                                                class: "d-flex align-center"
                                              }, {
                                                default: _withCtx(() => _cache[84] || (_cache[84] = [
                                                  _createElementVNode("b", null, " Indiquez le premier jour de la période à déclarer : ", -1)
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "3",
                                                class: "d-flex justify-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_oss_date_picker_filled, {
                                                    modelValue: _ctx.newDeclarationStartDate,
                                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.newDeclarationStartDate) = $event)),
                                                    "hide-details": "",
                                                    textFieldReadOnly: false,
                                                    minDate: _ctx.accountingPeriodStart,
                                                    maxDate: _ctx.accountingPeriodEnd
                                                  }, null, 8, ["modelValue", "minDate", "maxDate"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_row, {
                                            "no-gutters": "",
                                            class: "mt-1 mb-5 d-flex justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "6",
                                                class: "d-flex align-center"
                                              }, {
                                                default: _withCtx(() => _cache[85] || (_cache[85] = [
                                                  _createElementVNode("b", null, " Indiquez le dernier jour de la période à déclarer : ", -1)
                                                ])),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "3",
                                                class: "d-flex justify-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_oss_date_picker_filled, {
                                                    modelValue: _ctx.newDeclarationEndDate,
                                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.newDeclarationEndDate) = $event)),
                                                    "hide-details": "",
                                                    textFieldReadOnly: false,
                                                    minDate: _ctx.accountingPeriodStart,
                                                    maxDate: _ctx.accountingPeriodEnd
                                                  }, null, 8, ["modelValue", "minDate", "maxDate"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : (
                                        [
                                            '3517SCA12',
                                            '3517BCA12',
                                            '2572',
                                            '1329DEF',
                                            '3030SD',
                                            '2573',
                                            'DAS2',
                                        ].includes(_ctx.selectedDeclarationForm.cerfaNumber)
                                    )
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 3,
                                      "no-gutters": "",
                                      class: "my-5"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "d-flex justify-center align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _cache[86] || (_cache[86] = _createElementVNode("h3", null, "Vérifiez la période de déclaration :", -1)),
                                            _createElementVNode("p", _hoisted_21, " du " + _toDisplayString(_ctx.formatDateWithSlash(_ctx.newDeclarationStartDate)) + " au " + _toDisplayString(_ctx.formatDateWithSlash(_ctx.newDeclarationEndDate)), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: "vatAutoDatesSelection" }, {
                        default: _withCtx(() => [
                          (['3310CA3'].includes(_ctx.selectedDeclarationForm.cerfaNumber))
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                "no-gutters": "",
                                class: "my-5 d-flex justify-center align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex justify-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        items: _ctx.CA3Periods,
                                        "item-title": "text",
                                        "item-value": "value",
                                        modelValue: _ctx.selectedCA3Period,
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.selectedCA3Period) = $event)),
                                        dense: "",
                                        label: "Période",
                                        outlined: "",
                                        "hide-details": "auto"
                                      }, null, 8, ["items", "modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_row, {
                                key: 1,
                                "no-gutters": "",
                                class: "my-5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "mt-5 d-flex justify-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "6",
                                            class: "d-flex align-center"
                                          }, {
                                            default: _withCtx(() => _cache[87] || (_cache[87] = [
                                              _createElementVNode("b", null, " Indiquez le premier jour de la période à déclarer : ", -1)
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "3",
                                            class: "d-flex justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_oss_date_picker_filled, {
                                                modelValue: _ctx.newDeclarationStartDate,
                                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.newDeclarationStartDate) = $event)),
                                                "hide-details": "",
                                                textFieldReadOnly: false,
                                                minDate: _ctx.accountingPeriodStart,
                                                maxDate: _ctx.accountingPeriodEnd
                                              }, null, 8, ["modelValue", "minDate", "maxDate"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "mt-1 mb-5 d-flex justify-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "6",
                                            class: "d-flex align-center"
                                          }, {
                                            default: _withCtx(() => _cache[88] || (_cache[88] = [
                                              _createElementVNode("b", null, " Indiquez le dernier jour de la période à déclarer : ", -1)
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "3",
                                            class: "d-flex justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_oss_date_picker_filled, {
                                                modelValue: _ctx.newDeclarationEndDate,
                                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.newDeclarationEndDate) = $event)),
                                                "hide-details": "",
                                                textFieldReadOnly: false,
                                                minDate: _ctx.accountingPeriodStart,
                                                maxDate: _ctx.accountingPeriodEnd
                                              }, null, 8, ["modelValue", "minDate", "maxDate"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: "vatAssistDatesSelection" }, {
                        default: _withCtx(() => [
                          (['3310CA3'].includes(_ctx.selectedDeclarationForm.cerfaNumber))
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                "no-gutters": "",
                                class: "my-5 d-flex justify-center align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex justify-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        items: _ctx.CA3Periods,
                                        "item-title": "text",
                                        "item-value": "value",
                                        modelValue: _ctx.selectedCA3Period,
                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.selectedCA3Period) = $event)),
                                        dense: "",
                                        label: "Période",
                                        outlined: "",
                                        "hide-details": "auto"
                                      }, null, 8, ["items", "modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_row, {
                                key: 1,
                                "no-gutters": "",
                                class: "my-5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "mt-5 d-flex justify-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "6",
                                            class: "d-flex align-center"
                                          }, {
                                            default: _withCtx(() => _cache[89] || (_cache[89] = [
                                              _createElementVNode("b", null, "Indiquez le premier jour de la période à déclarer :", -1)
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "3",
                                            class: "d-flex justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_oss_date_picker_filled, {
                                                modelValue: _ctx.newDeclarationStartDate,
                                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.newDeclarationStartDate) = $event)),
                                                "hide-details": "",
                                                textFieldReadOnly: false,
                                                minDate: _ctx.accountingPeriodStart,
                                                maxDate: _ctx.accountingPeriodEnd
                                              }, null, 8, ["modelValue", "minDate", "maxDate"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "mt-1 mb-5 d-flex justify-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "6",
                                            class: "d-flex align-center"
                                          }, {
                                            default: _withCtx(() => _cache[90] || (_cache[90] = [
                                              _createElementVNode("b", null, "Indiquez le dernier jour de la période à déclarer :", -1)
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, {
                                            cols: "3",
                                            class: "d-flex justify-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_oss_date_picker_filled, {
                                                modelValue: _ctx.newDeclarationEndDate,
                                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.newDeclarationEndDate) = $event)),
                                                "hide-details": "",
                                                textFieldReadOnly: false,
                                                minDate: _ctx.accountingPeriodStart,
                                                maxDate: _ctx.accountingPeriodEnd
                                              }, null, 8, ["modelValue", "minDate", "maxDate"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "title", "previous-display", "valid-disabled", "hideValid"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_tabs_window_item, {
          key: "taxDeclarations",
          value: "taxDeclarations"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "px-4"
            }, {
              default: _withCtx(() => [
                (_ctx.selectedCompany && !_ctx.isInAdmin && !_ctx.isAccountingCustomer)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "2",
                      class: "d-flex justify-space-around",
                      "vertical-align": "center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn_primary, {
                          block: "",
                          elevation: "0",
                          class: "rounded-lg gradient mt-2",
                          disabled: _ctx.disableNewBundleCreation,
                          onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.newBundleAction())),
                          size: "large",
                          "data-cy": "TaxFormTable-add"
                        }, {
                          default: _withCtx(() => _cache[91] || (_cache[91] = [
                            _createTextVNode(" Nouvelle Liasse ")
                          ])),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "mt-2",
                  fluid: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table_server, {
                      "items-per-page": _ctx.bundlesPerPage,
                      "onUpdate:itemsPerPage": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.bundlesPerPage) = $event)),
                      page: _ctx.bundlesPage,
                      "onUpdate:page": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.bundlesPage) = $event)),
                      "items-length": _ctx.totalBundles,
                      headers: _ctx.bundlesTableHeaders,
                      items: _ctx.filteredBundles,
                      "item-key": "id",
                      class: "table rounded-xl",
                      "fixed-header": "",
                      height: "65vh",
                      hover: true,
                      "prev-icon": "$chevron-left",
                      "next-icon": "$chevron_right",
                      "data-cy": "taxFormList-table"
                    }, {
                      [`header.checkbox`]: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_v_checkbox, {
                            color: "primary",
                            indeterminate: 
                                            !!_ctx.bundlesSelected.length &&
                                            _ctx.bundlesSelected.length !== _ctx.filteredBundles.length
                                        ,
                            class: "pa-0 ma-0 mr-1 pl-1",
                            ripple: false,
                            disabled: !_ctx.filteredBundles.length,
                            "hide-details": "",
                            onClick: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (_ctx.selectAllBundles()), ["stop"])),
                            "model-value": 
                                            _ctx.filteredBundles.length !== 0 &&
                                            _ctx.bundlesSelected.length === _ctx.filteredBundles.length
                                        
                          }, null, 8, ["indeterminate", "disabled", "model-value"]),
                          (_ctx.isAccountingUser)
                            ? (_openBlock(), _createBlock(_component_v_menu, {
                                key: 0,
                                "offset-y": ""
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn_icon, _mergeProps(props, {
                                    class: "ml-9",
                                    icon: "$dots_vertical"
                                  }), null, 16)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item, {
                                        disabled: _ctx.isDeleteBundleDisable,
                                        onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.dialogDeleteSelectedBundles = true))
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            disabled: _ctx.isDeleteBundleDisable,
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => _cache[93] || (_cache[93] = [
                                              _createTextVNode("$delete")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => _cache[92] || (_cache[92] = [
                                              _createTextVNode("Supprimer")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      "no-data": _withCtx(() => _cache[94] || (_cache[94] = [
                        _createTextVNode("Aucune liasse")
                      ])),
                      item: _withCtx(({ item }) => [
                        _createElementVNode("tr", {
                          onClick: ($event: any) => (_ctx.openDeclaration(item))
                        }, [
                          _createElementVNode("td", _hoisted_24, [
                            _createVNode(_component_v_checkbox, {
                              color: "primary",
                              "v-model": _ctx.bundlesSelected,
                              "hide-details": "",
                              class: "mt-0 pt-0 ml-1",
                              onClick: _withModifiers(($event: any) => (_ctx.selectBundle(item.id)), ["stop"]),
                              "model-value": _ctx.bundlesSelected.includes(item.id)
                            }, null, 8, ["v-model", "onClick", "model-value"])
                          ]),
                          (_ctx.isInAdmin)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                                _createElementVNode("b", {
                                  "data-cy": `bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-company`
                                }, _toDisplayString(item.company.name), 9, _hoisted_26)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", {
                            class: _normalizeClass(_ctx.isInAdmin ? 'text-center' : 'text-left')
                          }, [
                            _createElementVNode("b", {
                              "data-cy": `bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-title`
                            }, _toDisplayString(item.title), 9, _hoisted_27)
                          ], 2),
                          _createElementVNode("td", {
                            class: "text-center",
                            "data-cy": `bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-taxSystem`
                          }, _toDisplayString(item.taxSystem), 9, _hoisted_28),
                          _createElementVNode("td", _hoisted_29, [
                            (item.accountingPeriod)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  "data-cy": `bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-accountingPeriod`
                                }, _toDisplayString(_ctx.formatDateWithSlash(item.accountingPeriod.start)) + " - " + _toDisplayString(_ctx.formatDateWithSlash(item.accountingPeriod.end)), 9, _hoisted_30))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_31, [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                                                item.status === 'ERROR'
                                                    ? 'text-red line-clamp-2'
                                                    : 'line-clamp-2'
                                            ),
                              "data-cy": `bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-status`
                            }, _toDisplayString(item.translateStatus), 11, _hoisted_32)
                          ]),
                          _createElementVNode("td", {
                            class: "text-center",
                            "data-cy": `bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-sendDate`
                          }, _toDisplayString(item.date ? _ctx.formatDateWithSlash(item.date) : ""), 9, _hoisted_33),
                          _createElementVNode("td", {
                            class: "text-center",
                            "data-cy": `bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-creationDate`
                          }, _toDisplayString(item.createdAt
                                                ? _ctx.formatDateWithSlash(item.createdAt)
                                                : ""), 9, _hoisted_34),
                          _createElementVNode("td", {
                            class: "text-center",
                            "data-cy": `bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-lastUpdateDate`
                          }, _toDisplayString(item.updatedAt
                                                ? _ctx.formatDateWithSlash(item.updatedAt)
                                                : ""), 9, _hoisted_35),
                          _createElementVNode("td", null, [
                            _createVNode(_component_TaxFormEDIReport, {
                              taxFormId: item.id,
                              onMtaeProofEvent: _ctx.mtaeProof,
                              "data-cy": `bundle-${item.company.name.split(' ')[0]}-${item.title.replace(/\s+/g, '')}-ediProof`,
                              companyFromTaxFormListForAdminMode: item.company,
                              accountingPeriodFromTaxFormListForAdminMode: 
                                                _ctx.isInAdmin && item.accountingPeriod
                                            
                            }, null, 8, ["taxFormId", "onMtaeProofEvent", "data-cy", "companyFromTaxFormListForAdminMode", "accountingPeriodFromTaxFormListForAdminMode"])
                          ])
                        ], 8, _hoisted_23)
                      ]),
                      _: 2
                    }, 1032, ["items-per-page", "page", "items-length", "headers", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.bundleInformationDialog)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 0,
                  modelValue: _ctx.bundleInformationDialog,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.bundleInformationDialog) = $event)),
                  title: "Information",
                  "valid-title": "Fermer",
                  onValid: _cache[45] || (_cache[45] = ($event: any) => (_ctx.bundleInformationDialog = false)),
                  onClose: _cache[46] || (_cache[46] = ($event: any) => (_ctx.bundleInformationDialog = false))
                }, {
                  default: _withCtx(() => _cache[95] || (_cache[95] = [
                    _createElementVNode("div", { style: {"width":"750px"} }, [
                      _createElementVNode("b", { class: "text-center my-5" }, " Seule la liasse fiscale 2035 concernant les BNC est disponible. bobbee met tout en oeuvre pour vous proposer très bientôt les autres liasses fiscales. ")
                    ], -1)
                  ])),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.manyBundlesOnSamePeriodDialog)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 1,
                  modelValue: _ctx.manyBundlesOnSamePeriodDialog,
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.manyBundlesOnSamePeriodDialog) = $event)),
                  title: "Attention",
                  "valid-title": "Valider",
                  onValid: _cache[48] || (_cache[48] = ($event: any) => {
                        _ctx.manyBundlesOnSamePeriodDialog = false;
                        _ctx.newBundle();
                    }),
                  onClose: _cache[49] || (_cache[49] = ($event: any) => (_ctx.manyBundlesOnSamePeriodDialog = false))
                }, {
                  default: _withCtx(() => _cache[96] || (_cache[96] = [
                    _createElementVNode("div", {
                      style: {"width":"750px"},
                      class: "d-flex justify-center align-center"
                    }, [
                      _createElementVNode("b", { class: "my-5" }, " Il existe déjà une liasse fiscale pour cette période, souhaitez-vous vraiment en générer une nouvelle ? ")
                    ], -1)
                  ])),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.dialogDeleteSelectedBundles,
              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.dialogDeleteSelectedBundles) = $event)),
              title: 
                        _ctx.bundlesSelected.length > 1
                            ? 'Supprimer des liasses'
                            : 'Supprimer une liasse'
                    ,
              onValid: _cache[51] || (_cache[51] = ($event: any) => (_ctx.deleteBundles()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("b", null, " Voulez-vous supprimer " + _toDisplayString(_ctx.bundlesSelected.length) + " liasse" + _toDisplayString(_ctx.bundlesSelected.length === 1 ? "" : "s") + " ? ", 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "title"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}